import axios from "axios";
import { host, port, path, version } from "../systemVariables";

const resource = "/producttransactiontypes";

export const LIST_LOCKERPROVISIONINGTRANSACTIONTYPES = "LIST_LOCKERPROVISIONINGTRANSACTIONTYPES";

export function getProductTransactionTypesByTransactionCategoryId(transactionCategoryId, callback) {
  return () => {
    axios
      .get(host + port + path + version + resource, {
        params: {
          transactionCategoryId,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      })
      .then((response) => {
        callback(response);
      })
      .catch((error) => {
        callback(error);
      });
  };
}

export function getLockerProvisioningTransactionTypes(callback) {
  return (dispatch) => {
    axios
      .get(host + port + path + version + resource, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      })
      .then((response) => {
        dispatch({ type: LIST_LOCKERPROVISIONINGTRANSACTIONTYPES, payload: response.data });
        callback(response);
      })
      .catch((error) => {
        callback(error);
        return error;
      });
  };
}
